import { render, staticRenderFns } from "./ReusableForm.vue?vue&type=template&id=04a8b42e&scoped=true&"
import script from "./ReusableForm.vue?vue&type=script&lang=ts&"
export * from "./ReusableForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReusableForm.vue?vue&type=style&index=0&id=04a8b42e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8b42e",
  null
  
)

export default component.exports